import script from "./BerechnungTeilen.vue?vue&type=script&setup=true&lang=js"
export * from "./BerechnungTeilen.vue?vue&type=script&setup=true&lang=js"

import "./BerechnungTeilen.vue?vue&type=style&index=0&id=ecbf1e0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecbf1e0c"]])

export default __exports__